export const campaignNoteValidator = values => {
  const errors: Record<string, any> = {}

  if (!values.note) errors.note = 'Note is required'

  if (values.note && values.note.length > 2048) errors.note = 'Note is too long'

  return errors
}
